import React from 'react';
import PropTypes from 'prop-types';

const Strings = require('../../../../app/shared/Strings');

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: '',
};

function LoadingSpinner(props) {
    return (
        <span className={`fa fa-refresh fa-spin loading-spinner ${props.className}`} aria-label={Strings['en'].common.LOADING} />
    );
}

LoadingSpinner.propTypes = propTypes;
LoadingSpinner.defaultProps = defaultProps;

export default LoadingSpinner;